import dynamic from 'next/dynamic';
import _ from 'lodash';
import { classNames } from '@farawaygg/utils-lotm';
import styles from './MintInProgress.module.css';
const DynamicBg = dynamic(() => import('#components/claim-koda/components/hyperspace'));
type MintInProgressProps = {
  webmBackgroundVideoPath?: string;
  mp4BackgroundVideoPath?: string;
  fetchingMetadata?: boolean;
  mintInProgressMessage?: string;
  showDotAnimation?: boolean;
};
export const MintInProgress = ({
  fetchingMetadata = false,
  webmBackgroundVideoPath,
  mp4BackgroundVideoPath,
  mintInProgressMessage = 'Transaction in progress',
  showDotAnimation = false
}: MintInProgressProps) => {
  return <section className="standard-wrapper flex h-screen w-screen items-center justify-center">
      <div className="pointer-events-none fixed left-0 top-0 -z-1 h-screen w-screen">
        <div className="absolute z-[999] h-screen w-screen bg-black/50" />
        {[webmBackgroundVideoPath, mp4BackgroundVideoPath].some(videoPath => videoPath !== undefined) ? <video className="absolute bottom-0 left-0 right-0 top-0 -z-10 h-full w-full object-cover" autoPlay playsInline loop muted>
            {webmBackgroundVideoPath !== undefined && <source src={webmBackgroundVideoPath} type="video/webm" />}
            {mp4BackgroundVideoPath !== undefined && <source src={mp4BackgroundVideoPath} type="video/mp4" />}
          </video> : <DynamicBg />}
      </div>
      <div className="mx-auto text-center">
        <p className="mb-6 font-chakra-petch text-xs uppercase text-white/80">
          {mintInProgressMessage}
        </p>
        <h3 className="text-center text-3xl uppercase md:text-[80px] md:leading-none">
          {fetchingMetadata ? 'Success!!! Loading your new assets' : 'Do not refresh'}
        </h3>
        {showDotAnimation && _.range(0, 4).map(idx => {
        const delay = idx * 300;
        return <div key={idx} className={classNames('mx-2 inline-block h-2 w-2 bg-white', styles.bounce)} style={{
          animationDelay: `${delay}ms`
        }} />;
      })}
      </div>
    </section>;
};